// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
require('./_set-collection-from')('WeakMap');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.11@core-js/modules/es7.weak-map.from.js
// module id = 644
// module chunks = 0